import showConnectionError from '@helpers/connection-error';

import * as actionTypes from './gateways-action-types';

export const initialState = {
  isLoadingAssignments: false,
  isAssigningAssignments: false,
  isUnAssigningAssignments: false,
  isLoadingPreviewAssignment: false,
  isLoadingClassrooms: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STUDENTS_ASSIGNMENTS_STATUSES_REQUEST: {
      return {
        ...state,
        isLoadingAssignments: true
      };
    }
    case actionTypes.STUDENTS_ASSIGNMENTS_STATUSES_SUCCESS: {
      return {
        ...state,
        isLoadingAssignments: false
      };
    }
    case actionTypes.ASSIGN_ASSIGNMENTS_REQUEST: {
      return {
        ...state,
        isAssigningAssignments: true
      };
    }
    case actionTypes.ASSIGN_ASSIGNMENTS_SUCCESS: {
      return {
        ...state,
        isAssigningAssignments: false
      };
    }
    case actionTypes.UNASSIGN_ASSIGNMENTS_REQUEST: {
      return {
        ...state,
        isUnAssigningAssignments: true
      };
    }
    case actionTypes.UNASSIGN_ASSIGNMENTS_SUCCESS: {
      return {
        ...state,
        isUnAssigningAssignments: false
      };
    }

    case actionTypes.PREVIEW_ASSIGNMENT_REQUEST: {
      return {
        ...state,
        isLoadingPreviewAssignment: true
      };
    }
    case actionTypes.PREVIEW_ASSIGNMENT_SUCCESS: {
      return {
        ...state,
        isLoadingPreviewAssignment: false
      };
    }

    case actionTypes.CLASSROOMS_REQUEST: {
      return {
        ...state,
        isLoadingClassrooms: true
      };
    }

    case actionTypes.CLASSROOMS_SUCCESS: {
      return {
        ...state,
        isLoadingClassrooms: false
      };
    }

    case actionTypes.ERROR_DETECTED: {
      // don't like be in here, but will refactor later
      showConnectionError();

      return {
        ...initialState
      };
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./containers/gateways/gateways-reducer.js